export default function HypesquadTab() {
    return (
        <h2>HypeSquad</h2>
    );
}